import { RadioGroup } from "@tql/ui-components-react/kendo/inputs";
import { memo } from "react";

import type { InvoiceStatus } from "../hooks/use-invoice-selection";

type InvoiceControlsProps = {
	currentStatus: InvoiceStatus;
	onFilterChange: (filter: InvoiceStatus) => void;
};

const FILTER_OPTIONS = [
	{ value: "openInvoices", label: "Open Invoices" },
	{ value: "pendingPayment", label: "Pending Payment" },
	{ value: "paidInvoices", label: "Paid Invoices" },
	{ value: "allInvoices", label: "All Invoices" },
];

export const InvoiceControls = memo(function InvoiceControls({
	currentStatus,
	onFilterChange,
}: InvoiceControlsProps) {
	return (
		<div className={"invoice-controls"}>
			<RadioGroup
				className={"invoice-status-radios"}
				data={FILTER_OPTIONS}
				layout={"horizontal"}
				onChange={(e: { value: string }) =>
					onFilterChange(e.value as InvoiceStatus)
				}
				value={currentStatus}
			/>
		</div>
	);
});

InvoiceControls.displayName = "InvoiceControls";
